<template>
  <a :href="goTopHref" title="Scroll back to top" :class="$style.up">
    <SvgIcon src="icon-sprite.svg#up_button" width="40" height="40" />
  </a>
</template>

<script>
import { defineComponent } from 'vue';
import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  name: 'GoTopButton',
  components: { SvgIcon },
  data: () => ({ locationHash: null }),
  computed: {
    goTopHref() {
      try {
        if (this.locationHash.includes('table-processes')) {
          return '#Process';
        }
      } catch {}

      return '#top';
    },
  },
  mounted() {
    window.addEventListener('hashchange', this.hashchange, false);
  },
  beforeUnmount() {
    window.removeEventListener('hashchange', this.hashchange, false);
  },
  methods: {
    hashchange() {
      this.locationHash = location.hash;
    },
  },
});
</script>

<style module lang="scss">
.up {
  position: sticky;
  bottom: 20px;

  &:not(:hover) {
    opacity: 0.75;
  }
}
</style>
